import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { CargoClassifierService } from 'src/app/core/services/cargo-classifier.service';
export type refreshCargoMassivePayments = {
  cargo: Cargo,
  action: 'update' | 'delete',
  index: number,
  typeLoads: 'available' | 'unavailable',
  reason?: string
}
@Component({
  selector: 'app-list-massive-payments-loads',
  templateUrl: './list-massive-payments-loads.component.html',
  styleUrls: ['./list-massive-payments-loads.component.scss']
})
export class ListMassivePaymentsLoadsComponent {
  //Inputs
  @Input() massiveLoadsList: (Cargo & { errorMessage?: string })[] = [];
  @Input() typeList: string = '';
  @Input() activeSelected: boolean = false;
  @Input() typeLoads: 'available' | 'unavailable';
  @Input() filters: string = '';
  // Outputs
  @Output() loadsSelected: EventEmitter<Cargo[]> = new EventEmitter();
  @Output() refreshLoads: EventEmitter<refreshCargoMassivePayments | null> = new EventEmitter();
  constructor(
    public cargoClassifierService: CargoClassifierService
  ) { }

  async refreshCargo(event: { cargo: Cargo, action: 'update' | 'delete', reason?: string }, index: number) {
    this.refreshLoads.emit(
      {
        cargo: event.cargo,
        action: event.action,
        index,
        typeLoads: this.typeLoads,
        reason: event.reason
      }
    );
  }
  // Getters
  get newFilters() {
    return this.filters + '&massiveOperation=true';
  }
}
